const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion) {
  const sections = document.querySelectorAll('#MainContent > .shopify-section');

  if (sections.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    sections.forEach((section, index) => {
      // Skip the very first section (hero) so above-the-fold content is never hidden waiting on JS/scroll.
      if (index === 0) return;
      section.classList.add('scroll-reveal-init');
      observer.observe(section);
    });
  }
}
